import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { QuestionBase } from '../models/application-questions/question-base';

@Injectable({
    providedIn: 'root',
})
export class QuestionControlService {
    constructor() {}

    toFormGroup(questions: QuestionBase<string>[]) {
        const group: any = {};

        questions.forEach((question) => {
            const phoneValidator: any[] = [];
            const emailValidator =
                question.controlType === 'email' ? [Validators.email] : [];
            const requiredValidator = question.required
                ? [Validators.required]
                : [];
            const zipValidator =
                question.label === 'Zip'
                    ? [Validators.minLength(5), Validators.maxLength(5)]
                    : [];

            group[question.key] = new FormControl(question.value || '', [
                ...phoneValidator,
                ...emailValidator,
                ...requiredValidator,
                ...zipValidator,
            ]);
        });
        return new FormGroup(group);
    }
}
